/**
 * Constantes partagées de l'application
 */

// Liste des mois
export const MOIS = [
  { value: 1, label: 'Janvier' },
  { value: 2, label: 'Février' },
  { value: 3, label: 'Mars' },
  { value: 4, label: 'Avril' },
  { value: 5, label: 'Mai' },
  { value: 6, label: 'Juin' },
  { value: 7, label: 'Juillet' },
  { value: 8, label: 'Août' },
  { value: 9, label: 'Septembre' },
  { value: 10, label: 'Octobre' },
  { value: 11, label: 'Novembre' },
  { value: 12, label: 'Décembre' }
];

// Liste des trimestres
export const TRIMESTRES = [
  { value: 'Q1', label: 'Q1 (Jan-Mar)' },
  { value: 'Q2', label: 'Q2 (Avr-Juin)' },
  { value: 'Q3', label: 'Q3 (Juil-Sep)' },
  { value: 'Q4', label: 'Q4 (Oct-Déc)' }
];

// Options de TVA
export const TVA_OPTIONS = [
  { value: 0, label: '0% (exonéré)' },
  { value: 0.055, label: '5,5% (réduit)' },
  { value: 0.1, label: '10% (intermédiaire)' },
  { value: 0.2, label: '20% (normal)' }
];

// Obtenir le nom d'un mois par sa valeur
export const getMoisLabel = (value) => {
  return MOIS.find(m => m.value === value)?.label || '';
};

// Obtenir le trimestre d'un mois
export const getTrimestreFromMois = (mois) => {
  if (mois <= 3) return 'Q1';
  if (mois <= 6) return 'Q2';
  if (mois <= 9) return 'Q3';
  return 'Q4';
};
